module.exports = __webpack_public_path__ + "img/browser.5d4c9899.png";